import { useEffect } from 'react'
import { useAppStore } from '@/store/useAppStore.ts'

export function useTheme() {
  const resolvedTheme = useAppStore((s) => s.resolvedTheme)

  useEffect(() => {
    document.documentElement.dataset.theme = resolvedTheme
  }, [resolvedTheme])

  return resolvedTheme
}
